import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import Loading from "../../components/Common/Loading";
import { MainContainer } from "../../helpers/StyledComponents";
import Card from "../../components/Common/Card";
import { Helmet } from "react-helmet";
import ActvitiesJson from "./activities.json";

const AllActivities = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const currentDomain = `${window.location.protocol}//${window.location.hostname}`;

  useEffect(() => {
    // Simulate async behavior (optional)
    const loadLocalData = async () => {
      try {
        setData(ActvitiesJson); // Use local JSON
      } catch (err) {
        console.error("Error loading local JSON:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    loadLocalData();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page); // Update the page state
  };

  const sortedData = [...data].sort((a, b) => b.actNo - a.actNo);

  const paginatedData = sortedData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  console.log("paginatedData", paginatedData);

  return (
    <MainContainer>
      <Helmet>
        <title>กิจกรรมทั้งหมด - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {paginatedData.map((item) => {
              return (
                <Card
                  key={item.actNo}
                  title={item.title}
                  image={item.images[0]?.image}
                  detailLink={`${currentDomain}/activities?actNo=${item.actNo}`}
                />
              );
            })}
          </div>
          <div
            style={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              current={currentPage}
              total={data.length}
              pageSize={pageSize}
              onChange={handlePageChange}
              showSizeChanger={false}
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      )}
    </MainContainer>
  );
};

export default AllActivities;
